import coreAPIInstance from "./coreApiInstance";

export const downloadStreamAPIs = {
  downloadStream: ({ payload }) => coreAPIInstance.post("/api/v1/jobs/download", payload),
  getDownloadUrl: ({ payload }) => coreAPIInstance.post("/api/v1/jobs/download-url", payload),
  getMatchJobDetails: ({ payload }) => coreAPIInstance.get(`/api/v1/jobs/${payload?.id}`, payload),
  getStreamMatchJobDetails: ({ streamId, entityId, payload }) =>
    coreAPIInstance.get(`/api/v1/jobs/stream/${streamId}`, {
      headers: { entityid: entityId },
      ...(payload?.params != null && { params: payload.params }),
    }),
  deleteStreamMatchJobDetails: ({ payload }) =>
    coreAPIInstance.delete(`/api/v1/jobs/${payload?.id}`, { headers: { entityid: payload?.entityId } }),
  stopStreamMatchJob: ({ payload }) => coreAPIInstance.post("/api/v1/jobs/stop", payload),
};
